import Model, {
  AsyncBelongsTo,
  AsyncHasMany,
  attr,
  belongsTo,
  hasMany,
} from '@ember-data/model';
import { TranslatedField } from 'admin-panel/constants/types';
import { translated } from 'admin-panel/utils/model';
import type ItemModel from './item';
import type PageItemModel from './page-item';
import type CategoryModel from './category';
import type HotelModel from './hotel';

export default class PageModel extends Model {
  @hasMany('page-item')
  declare pageItems: AsyncHasMany<PageItemModel>;

  @hasMany('item')
  declare items: AsyncHasMany<ItemModel>;

  @belongsTo('category')
  declare category: AsyncBelongsTo<CategoryModel>;

  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @attr
  declare cleanType: string;

  @attr
  declare position: number;

  @attr
  declare active?: boolean;

  @attr
  declare titleTranslations?: TranslatedField;

  @attr
  declare contentTranslations?: TranslatedField;

  @translated
  declare title: string;

  @translated
  declare content: string;

  get itemsCount() {
    return this.hasMany('items' as Exclude<keyof this, keyof Model>).ids()
      .length;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    page: PageModel;
  }
}
